module.exports = __webpack_public_path__ + "static/img/img-yybs.8fddad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-yybs.png
// module id = 9E8O
// module chunks = 0